<template>
  <div
    class="item"
    :class="{ current: stepNumber === currentRegistrationStep }"
  >
    <span class="circle-icon">{{ stepNumber }}</span>
    <span class="text">{{ label }}</span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    stepNumber: {
      type: Number,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(["currentRegistrationStep"])
  }
};
</script>

<style scoped>
.item {
  color: white;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.item.current .circle-icon {
  color: #5290f3;
  border: 2px solid #5290f3;
}

.item.current .text {
  color: #5290f3;
}

.circle-icon {
  min-width: 25px;
  min-height: 25px;
  margin-right: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  border: 2px solid #c3c3c3;
  border-radius: 50%;
}

.text {
  font-size: 12px;
  font-weight: 300;
}
</style>
